module.exports = __webpack_public_path__ + "img/icon7.35c49428.jpg";